export default {
  buttonStyle: {
    width: 38,
    height: 38,
    minHeight: 38,
    lineHeight: 1,
  },
};
